import { Link, useLocation } from "react-router-dom";
import SunAccent from "@/components/feature/SunAccent";
import Seo from "@/components/feature/Seo";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 bg-background-50">
      <Seo
        title="Page Not Found | Rythugaru Agri Tourism"
        description="The page you're looking for isn't here. Return to Rythugaru Agri Tourism to explore farm and village experiences in Konaseema, India."
        path={location.pathname}
        noindex
      />
      <span className="absolute bottom-0 text-9xl md:text-[12rem] font-heading font-black text-background-200 select-none pointer-events-none z-0">
        404
      </span>
      <div className="relative z-10 flex flex-col items-center">
        <SunAccent className="mb-6" circleClassName="w-12 h-12" iconClassName="text-2xl" />
        <h1 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950">
          This page has not been generated
        </h1>
        <p className="mt-3 text-sm md:text-base text-foreground-500 font-mono">
          {location.pathname}
        </p>
        <p className="mt-4 text-base md:text-lg text-foreground-700 max-w-md">
          The page you're looking for isn't here yet. Let's get you back to the fields.
        </p>
        <Link
          to="/"
          className="mt-8 inline-flex items-center gap-2 bg-primary-500 text-background-50 text-sm font-semibold px-7 py-3.5 rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-home-4-line"></i>
          Back to Home
        </Link>
      </div>
    </div>
  );
}